import Sidebar from "components/navigation-2/sidebar";
import HRNavigationMenu from "components/hr/HRNavigationMenu";

export default function LayoutHR({ children }) {
  return (
    <div className="page hr-app-scope">
      <Sidebar>
        {/* HR Navigation Menu - appears below topbar */}
        <HRNavigationMenu />
        
        <div className="page-wrapper">
          {children}
        </div>
      </Sidebar>
    </div>
  );
}
